import bindFieldRelation from './bindFieldRelation.vue'
export default bindFieldRelation
